import * as React from 'react';
import { useMemo } from 'react';
import clsx from 'clsx';
// @ts-ignore
import styles from '../../../CustomerDashboard.module.scss?module';
import { ProductAttributeInterface } from '../../../../../../../Interface/ProductAttribute';
import { ProductSizeInterface } from '../../../../../../../Interface/ProductSize';
import { getProductSizeDiscountDisplay } from '../../../../../../Helper/flavourDiscount';
import ProductAttributeName from '../../../../../../Abstracts/ProductAttribute/ProductAttributeName/ProductAttributeName';
import Availability from '../../../../../../Abstracts/ProductAttribute/Availability/Availability';
import QuantityOrNotify from '../../../../../../Abstracts/ProductAttribute/QuantityOrNotify/QuantityOrNotify';

interface QuickOrderFlavourRowProps {
  product_attribute: ProductAttributeInterface;
  product_size: ProductSizeInterface;
}

/* One flavour with its quantity field. The field writes into the surrounding
   ProductListProvider, the same way the flavour rows of the product page do. */
export default function QuickOrderFlavourRow({
  product_attribute,
  product_size,
}: QuickOrderFlavourRowProps) {
  // A clearance flavour (short expiry, own price) is listed next to the regular
  // flavour of the same name. The name block of the product page tells them apart
  // with the clearance reason; percent and price follow the product page's rule.
  const showFlavourDiscount = useMemo(
    () => getProductSizeDiscountDisplay(product_size).showFlavourDiscount,
    [product_size]
  );

  return (
    <div className={styles.flavourRow}>
      <ProductAttributeName
        product_attribute={product_attribute}
        isUserLoggedIn
        showDiscountDetails={showFlavourDiscount}
      />
      {/* Below md the name block shows its own availability dot, so this column
          is hidden there, as on the product page. */}
      <div className="d-none d-md-flex">
        <Availability product_attribute={product_attribute} />
      </div>
      {/* QuantityOrNotify shows the notify link instead of the field when the
          flavour has no stock. Compact, it is a bell with "Notify me" from md
          up and the bell alone below; the label needs the wider box. The box
          is a label, so a tap on its hit area below md focuses the field;
          around the notify link it does nothing. */}
      <label
        className={clsx(
          styles.quantity,
          !product_attribute.has_stock && styles.quantityNotify
        )}
      >
        <QuantityOrNotify
          product_attribute={product_attribute}
          price={product_size.price ?? 0}
          combined_price={product_attribute.combined_price}
          notifyCompact
        />
      </label>
    </div>
  );
}
